import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit, signal } from "@angular/core";
import { Subject, switchMap, takeUntil } from "rxjs";
import { DeviceServiceService } from "src/app/services/device-service/device-service.service";

@Component({
  selector: "app-banner-image",
  templateUrl: "./banner-image.component.html",
  styleUrl: "./banner-image.component.scss",
  imports: [CommonModule],
})
export class BannerImageComponent implements OnInit {
  @Input() bannerImageUrl =
    "./assets/media/media-cloned/landing/banner.jpg";
  @Input() bannerClasses = "";
  @Input() bannerOpacity = 0.6;
  @Input() bannerSize: "cover" | "contain" | "inherit" | "unset" = "cover";
  @Input() bannerPosition: "center" | "top" | "bottom" | "left" | "right" =
    "center";

  destroy$ = new Subject<void>();
  isMobile = signal<boolean | null>(null);

  #deviceDetection = inject(DeviceServiceService);

  get bannerImage() {
    return {
      "background-image": `linear-gradient(rgba(255,255,255,${this.bannerOpacity}), rgba(255,255,255,${this.bannerOpacity})), url(${this.bannerImageUrl})`,
      "background-position": this.bannerPosition,
      "background-size": this.bannerSize,
      "background-repeat": "no-repeat",
    };
  }

  ngOnInit(): void {
    this.mobileDetector();
  }

  mobileDetector() {
    this.isMobile.update((_) => this.#deviceDetection.mobileDeviceListener());
    this.#deviceDetection
      .onResize()
      .pipe(
        switchMap(() => this.#deviceDetection.isMobile$),
        takeUntil(this.destroy$)
      )
      .subscribe((is_mobile: boolean) => {
        if (this.isMobile() !== is_mobile) {
          this.isMobile.update((_) => is_mobile);
        }
      });
  }
}
